<template>
  <div class="grid grid-cols-1 gap-4" :class="regionLocked ? 'md:grid-cols-2' : 'md:grid-cols-3'">
    <PlaylistDropdown
      :model-value="playMode"
      :play-modes="playModes"
      @update:model-value="pickMode"
    />
    <MapsDropdown
      :model-value="mapName ? [mapName] : []"
      :cs-maps="maps"
      single
      @update:model-value="(names) => $emit('update:mapName', names[0] || null)"
    />
    <RegionDropdown
      v-if="!regionLocked"
      :model-value="region"
      :regions="regions"
      @update:model-value="(r) => $emit('update:region', r)"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import PlaylistDropdown from '../Matchmaking/PlaylistDropdown.vue';
import MapsDropdown from '../Matchmaking/MapsDropdown.vue';
import RegionDropdown from '../Matchmaking/RegionDropdown.vue';

const props = defineProps({
  playMode: { type: Object, default: null },
  mapName: { type: String, default: null },
  region: { type: Object, default: null },
  playModes: { type: Array, default: () => [] },
  regions: { type: Array, default: () => [] },
  regionLocked: { type: Boolean, default: false },
});

const emit = defineEmits(['update:playMode', 'update:mapName', 'update:region']);

const byName = (a, b) => a.friendly_name.localeCompare(b.friendly_name);
const maps = computed(() => [...(props.playMode?.cs_maps || [])].sort(byName));

function pickMode(mode) {
  emit('update:playMode', mode);
  if (!mode.cs_maps?.some((map) => map.name === props.mapName)) emit('update:mapName', [...(mode.cs_maps || [])].sort(byName)[0]?.name || null);
}
</script>
